import { INPUT_FIELD_TYPES, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, EVENTS_FIELD_TYPES } from './input-field-types';
import { READONLY_FIELD_TYPES } from './readonly-field-types';
import { DEXT_FIELD_TYPES } from './dext-field-types';
export const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES
};
// eslint-disable-next-line @typescript-eslint/no-redeclare

export { INPUT_FIELD_TYPES, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, READONLY_FIELD_TYPES, DEXT_FIELD_TYPES, EVENTS_FIELD_TYPES };
//# sourceMappingURL=field-types.js.map